import { ApplicationConfig } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top'
      })
    ), 
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    // App-wide default: size each mat-form-field's hint/error area to its
    // actual content height instead of Material's default fixed single-line
    // reservation. With "fixed" sizing, a mat-hint that wraps to 2+ lines
    // (several forms have long hint sentences, e.g. AppointmentBuilderComponent's
    // "This Service Address is linked to more than one subscription...")
    // overflows past the reserved subscript area and visually overlaps the
    // next field's label/input below it - exactly the overlap being fixed
    // here. "dynamic" sizing grows the field's own height to fit its hint,
    // which pushes every subsequent field down instead of overlapping it.
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { subscriptSizing: 'dynamic' },
    },
  ]
};
